import React from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'
import GlobeIcon from '../../elements/icons/GlobeIcon'
import { transactionTimeStamp } from '../../../utils'
import BuildingIcon from '../../elements/icons/BuildingIcon'


const ExaminationCard = ({examination, openExamination}) => {
  return (
    <div className='p-3'>
        <p className='font-medium'>{examination.name}</p>
        <p className='text-sm text-gray-500 truncate'>{examination.description}</p>
        <p className='text-lg text-gray-500 font-medium'>
            <span className='text-xs text-gray-400 mt-3'>Passing score: </span><span className='font-orbitron'>{examination.passingScore}%</span>
        </p>
        <div className="w-full flex items-center justify-between mt-3 border-b">
          <p className='w-full pb-2  text-xl mt-2 font-outfit font-medium'>
          <span className='text-xs text-gray-400'>Fee: </span>₦{examination.fee ? (examination.fee.amount/100).toLocaleString() : '0.00'}</p>

          {/* {e.active ? <span className='bg-green-500 bg-opacity-10 text-green-500 text-xs px-2 rounded py-1 font-medium'>Active</span>
          : */}
          <span className={`px-2 rounded text-xs font-outfit py-1 flex items-center gap-x-1 justify-center bg-opacity-10 ${examination.mode === 'ONLINE' ? 'text-blue-500 bg-blue-600' : 'bg-vcm-light-purple text-vcm-purple'}`}>
          {examination.mode === 'ONLINE' ? <GlobeIcon className={`w-5 h-5`} /> : <BuildingIcon className={`w-5 h-5`} />}
          {examination.mode}</span>
          {/* } */}
        </div>

        <span className='text-xs text-gray-400 block mt-3'>Examination Dates: </span>
        <p className='w-full pb-2  text-xl font-outfit font-medium mt-2'>
            {examination.dates.map((date, dateIndex)=>(
                <span key={dateIndex} className='rounded px-2 py-1 text-xs bg-gray-100 text-gray-700 inline-block mr-2 mb-2'>{transactionTimeStamp(date.date).date}: {date.startTime} - {date.endTime}</span>
            ))}
        </p>
        <div className="w-full flex items-center justify-between mt-3">
            <button onClick={()=>{openExamination()}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit Examination <ArrowIcon className={`w-5 h-5`} /></button> 

            <button className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                <TrashIcon className={`w-5 h-5`} />
            </button>
        </div>

    </div>
  )
}

export default ExaminationCard